import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FormHelperText } from "@mui/material";
import { FieldError } from "react-hook-form";

import { EditorContainer } from "./styled";

import { TextFieldSchema } from "@/types/form-generator-schema-type";

interface IProps {
    field: any;
    errorMessage: FieldError;
    label: string;
    placeholder: string;
    props?: TextFieldSchema["props"];
}

const FormRichTextEditor = ({ field, errorMessage, placeholder, props = {} }: IProps) => {
    const defaultDirection = props?.dir || "ltr";
    const modules = {
        toolbar: [
            // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ direction: defaultDirection }],
        ],
    };

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "align",
        "direction",
        "link",
        "image",
        "video",
    ];

    return (
        <div>
            <EditorContainer direction={defaultDirection}>
                <ReactQuill
                    formats={formats}
                    modules={modules}
                    placeholder={placeholder}
                    theme="snow"
                    value={field.value || ""}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                />
            </EditorContainer>
            {errorMessage?.message ? <FormHelperText error>{errorMessage?.message}</FormHelperText> : null}
        </div>
    );
};

export default FormRichTextEditor;
